import { css } from '@/styled-system/css';

export const resendRow = css({
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  gap: 'tightest',
  flexWrap: 'wrap',
});

// FieldSet's own description spacing is `tightest` (4px), which reads fine under a single
// input but cramped directly beneath a row of six large boxes. One step up, still on the
// token scale — everything else about the feedback stays Constellation's.
export const feedback = css({
  display: 'block',
  marginBlockStart: 'tighter',
});
